import * as React from 'react';

import type { FluxibleContext } from 'fluxible';
import FluxibleComponent from 'vendor/cnpm/fluxible.v0-4/addons/FluxibleComponent';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import app from 'bundles/workspaces-app/app/app';

import 'css!bundles/workspaces-app/app/styl/all';

/**
 * Workspaces application.
 */
const Application = (props: React.PropsWithChildren) => {
  return <div className="rc-Application">{props.children}</div>;
};

class FluxibleApplication extends React.Component {
  UNSAFE_componentWillMount() {
    this.fluxibleContext = app.createContext();
  }

  fluxibleContext: FluxibleContext | null = null;

  render() {
    return (
      <FluxibleComponent context={this.fluxibleContext && this.fluxibleContext.getComponentContext()}>
        <Application {...this.props} />
      </FluxibleComponent>
    );
  }
}

export default FluxibleApplication;
